import {MUTATION_KEYS} from '@/queryClient'
import {httpEmailActivation} from '@/services/auth.http'
import {useMutation} from '@tanstack/react-query'

export const useEmailActivation = () =>
    useMutation({
        mutationKey: [MUTATION_KEYS.EMAIL_ACTIVATION],
        mutationFn: (value: string | null) => httpEmailActivation(value)
    })
